<template>
  <v-flex xs12 class="mb-4">
    <div class style="position: relative;">
      <div class="flex-container-space-between vertical-center-container">
        <page-title :routeProps="routeProps"></page-title>
        <div class="text-xs-right">
          <v-btn
            :icon="!$vuetify.breakpoint.smAndUp"
            :color="$store.state.global.pages.rate.color"
            flat
            router
            :to="{name: 'rate'}"
          >
            <v-icon :left="$vuetify.breakpoint.smAndUp">{{$store.state.global.pages.rate.icon}}</v-icon>
            {{$vuetify.breakpoint.smAndUp ? 'Show Rates' : ''}}
          </v-btn>
          <v-btn flat color="grey" @click="toggleView()">
            <v-icon left v-if="listView">list</v-icon>
            <v-icon left v-else>view_module</v-icon>View
          </v-btn>
        </div>
      </div>
      <layout-no-padding>
        <v-flex xs12 sm6 lg3>
          <div class="flex-container-space-between">
            <v-autocomplete
              :prepend-icon="$store.state.global.pages.client.icon"
              :color="$store.state.global.pages.client.color"
              label="Client"
              :items="clients"
              v-model="client"
              item-text="name"
              :clearable="true"
              item-value="id"
            ></v-autocomplete>
            <div class="ml-3" v-if="!!client">
              <v-switch
                :color="$store.state.global.pages.client.color"
                label="Details"
                v-model="showDetails"
              ></v-switch>
            </div>
          </div>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-select
            label="Sort by..."
            :items="sortFactors"
            v-model="sortBy"
            prepend-icon="sort"
            :disabled="listView"
            dense
          ></v-select>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-text-field label="Filter by..." v-model="filterBy" prepend-icon="filter_list"></v-text-field>
        </v-flex>

        <!--CONTROL INFO DISPLAY -->
        <control-info-display :data="clientObj" route="client" v-model="showDetails"></control-info-display>
      </layout-no-padding>

      <v-dialog
        v-model="addProjectDialog"
        max-width="500px"
        @keydown.esc="addProjectDialog = false"
        v-if="userAuthClass"
      >
        <v-btn fab dark :color="routeProps.color" class="overlap-fab-project" slot="activator">
          <v-icon dark>add</v-icon>
        </v-btn>
        <!-- ADD DRIVER COMPONENT-->
        <add-project @close="addProjectDialog = false"></add-project>
      </v-dialog>
      <card-divider-split></card-divider-split>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </v-flex>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import ProjectValidation from "@/services/validation/projectValidation";
import AddProject from "@/components/projects/addProject";
import ControlInfoDisplay from "@/components/ui/controlInfoDisplay";
import RouteProps from "@/services/mixins/routeProps";

//GET RECORDS
import getProjects from "@/services/mixins/getMasterFiles/getProjects";
import getTips from "@/services/mixins/getMasterFiles/getTips";
import getClients from "@/services/mixins/getMasterFiles/getClients";
export default {
  mixins: [ProjectValidation, RouteProps, getProjects, getTips, getClients],
  data() {
    return {
      addProjectDialog: false,
      sortFactors: [
        {
          value: "id",
          text: "ID"
        },
        {
          value: "name",
          text: "Name"
        },
        {
          value: "client.name",
          text: "Client"
        },
        {
          value: "updatedAt",
          text: "Updated At"
        }
      ]
    };
  },
  methods: {
    toggleView() {
      this.listView = !this.listView;
    },
    sortProjects(path1, path2) {
      return this.projects.sort((a, b) => {
        if (a[path] < b[path]) {
          return -1;
        } else {
          return 1;
        }
      });
    }
  },
  computed: {
    clientObj() {
      if (!!this.client) {
        return this.getObjByPrimaryId(this.client, this.clients);
      } else {
        return null;
      }
    },
    sortBy: Store.getSet({ store: "projects", prop: "sortBy" }),
    filterBy: Store.getSet({ store: "projects", prop: "filterBy" }),
    listView: Store.getSet({ store: "projects", prop: "listView" }),
    client: Store.getSet({ store: "projects", prop: "client" }),
    showDetails: Store.getSet({ store: "projects", prop: "showDetails" })
  },
  components: {
    AddProject,
    ControlInfoDisplay
  },
  watch: {
    clientObj(val) {
      if (!!val) {
        this.showDetails = true;
      } else {
        this.showDetails = false;
      }
    }
  }
};
</script>

<style scoped>
.overlap-fab-project {
  right: 40px;
  bottom: -17px;
  position: absolute !important;
}
</style>


